// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2084 ? "9b0008ae" : chunkId) + "." + {"2084":"181ed5b32e01edef","4525":"0c93308dcff08d59","9735":"7d02f3cf63d8b14b"}[chunkId] + ".js";
};